import { render, staticRenderFns } from "./NoticeForm.vue?vue&type=template&id=8410478c&"
import script from "./NoticeForm.vue?vue&type=script&lang=js&"
export * from "./NoticeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports